import gql from 'graphql-tag'

export const DESTROY_USER = gql`
  mutation DestroyUser($userId: Int!) {
    destroyUser(userId: $userId) {
      id
    }
  }
`
